import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker (PWA). Tolerant to dev/non-HTTPS environments.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("[SignalAgent] SW registered, scope:", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[SignalAgent] SW registration failed:", err);
      });
  });
}
